import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type UserRole = "student" | "teacher" | "parent";

export interface Profile {
  id: string;
  role: UserRole;
  full_name: string | null;
  name: string | null;
  email: string | null;
  phone: string | null;
  bio: string | null;
  looking_for: string | null;
  wechat_id: string | null;
  whatsapp_id: string | null;
  subjects: string | null;
  score: number;
  weekly_streak: number;
  last_login_week: string | null;
  avatar_url: string | null;
  grade: string | null;
  region: string | null;
  documents: { name: string; url: string; type: string; uploaded_at: string }[];
}

export interface Donation {
  id: string;
  donor_name: string;
  amount: number;
  message: string | null;
  is_anonymous: boolean;
  created_at: string;
}

export interface Gift {
  id: string;
  village_student_name: string;
  village_location: string;
  gift_type: string;
  gift_description: string | null;
  photo_url: string | null;
  shipped_at: string | null;
  created_at: string;
}

export interface VillageStory {
  id: string;
  author_name: string;
  location: string;
  title: string;
  content: string;
  photo_url: string | null;
  created_at: string;
}

export interface FarmVegetable {
  id: string;
  user_id: string;
  vegetable_type: string;
  growth_stage: number;
  score_spent: number;
  planted_at: string;
  harvested_at: string | null;
}
